    
export default class UtilFile{

    static openFileInNewWindow = (file) => {
        
        if(this.isNotFile(file)){
            return;
        }

        try {

            const fileURL = URL.createObjectURL(file);

            const link = document.createElement('a');
            link.href = fileURL;
            link.download = file.name || 'downloaded_file';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // window.open(fileURL, '_blank', 'noopener,noreferrer');

            setTimeout(() => {
                URL.revokeObjectURL(fileURL);
            }, 10000);

        } catch (error) {

            console.error('Erro ao abrir arquivo em nova janela:', error);

        }

    }

    static isFile = (file) => {

        if(file === null){
            return false;
        }

        if(file === undefined){
            return false;
        }

        if(!(file instanceof File)){
            return false;
        }

        return true;

    }

    static isNotFile = (file) => {

        return !this.isFile(file);

    }

}
